export const gasStationRouter = [
  {
    path: '/gasStation',
    name: 'gasStation',
    component: () => import('views/gasStation/index'),
    meta: {
      title: '',
      keepAlive: true
    }
  },
  {
    path: '/gasStation/orderManagement',
    name: 'gasStationOrderManagement',
    component: () => import('views/gasStation/orderManagement'),
    meta: {
      title: '订单查询'
    }
  },
  {
    path: '/gasStation/orderManagement/orderScreen',
    name: 'gasStationOrderScreen',
    component: () => import('views/gasStation/orderManagement/orderScreen'),
    meta: {
      title: '订单筛选'
    }
  },
  {
    path: '/gasStation/orderManagement/orderScreenResult',
    name: 'gasStationOrderScreenResult',
    component: () => import('views/gasStation/orderManagement/orderScreenResult'),
    meta: {
      title: '筛选结果'
    }
  },
  {
    path: '/gasStation/unusualOrder',
    name: 'gasStationUnusualOrder',
    component: () => import('views/gasStation/orderManagement/unusualOrder'),
    meta: {
      title: '异常订单'
    }
  },
  {
    path: '/gasStation/orderManagement/orderDetail',
    name: 'gasStationOrderDetail',
    component: () => import('views/gasStation/orderManagement/orderDetail'),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/gasStation/oilManagement',
    name: 'gasStationOilManagement',
    component: () => import('views/gasStation/oilManagement'),
    meta: {
      title: '油品管理'
    }
  },
  {
    path: '/gasStation/oilManagement/add',
    name: 'gasStationOilManagementAdd',
    component: () => import('views/gasStation/oilManagement/add'),
    meta: {
      title: '添加油品'
    }
  },
  {
    path: '/gasStation/discountManagement',
    name: 'gasStationDiscountManagement',
    component: () => import('views/gasStation/discountManagement'),
    meta: {
      title: '折扣管理'
    }
  },
  {
    path: '/gasStation/discountManagement/add',
    name: 'gasStationDiscountManagementAdd',
    component: () => import('views/gasStation/discountManagement/add'),
    meta: {
      title: '添加折扣'
    }
  },
  {
    path: '/gasStation/gasGunManagement',
    name: 'gasGunManagement',
    component: () => import('views/gasStation/gasGunManagement'),
    meta: {
      title: '油枪管理'
    }
  },
  {
    path: '/gasStation/gasGunManagement/add',
    name: 'gasGunManagementAdd',
    component: () => import('views/gasStation/gasGunManagement/add'),
    meta: {
      title: '添加油枪'
    }
  },
  {
    path: '/gasStation/printSet',
    name: 'printSet',
    component: () => import('views/gasStation/printSet'),
    meta: {
      title: '打印设置'
    }
  },
  {
    path: '/gasStation/minaProgramCode',
    name: 'minaProgramCode',
    component: () => import('views/gasStation/minaProgramCode'),
    meta: {
      title: '小程序码'
    }
  },
  {
    path: '/gasStation/intelligenceBox',
    name: 'gasStationIntelligenceBox',
    component: () => import('views/gasStation/settings/intelligenceBox'),
    meta: {
      title: '配置智慧盒子'
    }
  },
  {
    path: '/gasStation/intelligenceBox/intelligenceBoxDetail',
    name: 'gasStationIntelligenceBoxDetail',
    component: () => import('views/gasStation/settings/intelligenceBox/intelligenceBoxDetail'),
    meta: {
      title: '设置智慧盒子'
    }
  },
  {
    path: '/gasStation/deviceCheck',
    name: 'gasStationDeviceCheck',
    component: () => import('views/gasStation/settings/deviceCheck'),
    meta: {
      title: '设备自检',
      keepAlive: true
    }
  },
  {
    path: '/gasStation/deviceCheck/abnormal',
    name: 'gasStationDeviceCheckAbnormal',
    component: () => import('views/gasStation/settings/deviceCheck/abnormal'),
    meta: {
      title: '异常帮助'
    }
  },
  {
    path: '/gasStation/deviceCheck/abnormal/faq1',
    name: 'gasStationDeviceCheckAbnormalFaq1',
    component: () => import('views/gasStation/settings/deviceCheck/abnormal/faq1'),
    meta: {
      title: '异常帮助'
    }
  },
  {
    path: '/gasStation/deviceCheck/abnormal/faq2',
    name: 'gasStationDeviceCheckAbnormalFaq2',
    component: () => import('views/gasStation/settings/deviceCheck/abnormal/faq2'),
    meta: {
      title: '异常帮助'
    }
  },
  {
    path: '/gasStation/deviceCheck/abnormal/faq3',
    name: 'gasStationDeviceCheckAbnormalFaq3',
    component: () => import('views/gasStation/settings/deviceCheck/abnormal/faq3'),
    meta: {
      title: '异常帮助'
    }
  },
  {
    path: '/gasStation/deviceCheck/abnormal/faq4',
    name: 'gasStationDeviceCheckAbnormalFaq4',
    component: () => import('views/gasStation/settings/deviceCheck/abnormal/faq4'),
    meta: {
      title: '异常帮助'
    }
  },
  {
    path: '/gasStation/printer',
    name: 'gasStationPrinter',
    component: () => import('views/gasStation/settings/printer'),
    meta: {
      title: '打印机设置'
    }
  },
  {
    path: '/gasStation/printer/addPrinter',
    name: 'gasStationPrinterAdd',
    component: () => import('views/gasStation/settings/printer/addPrinter'),
    meta: {
      title: '设置打印机',
      keepAlive: true
    }
  },
  {
    path: '/gasStation/printer/printerModelSelect',
    name: 'gasStationPrinterModelSelect',
    component: () => import('views/gasStation/settings/printer/printerModelSelect'),
    meta: {
      title: '选择打印型号'
    }
  },
  {
    path: '/gasStation/printer/addPrinter/printerSpecifications',
    name: 'gasStationPrinterSpecifications',
    component: () => import('views/gasStation/settings/printer/printerSpecifications'),
    meta: {
      title: '选择打印规格'
    }
  },
  {
    path: '/gasStation/minaProgramLink',
    name: 'gasStationMinaProgramLink',
    component: () => import('views/gasStation/minaProgramLink'),
    meta: {
      title: '小程序链接'
    }
  }
]
